import { InjectableClass } from '@fino/lib-injection';
import { TranslateModalController } from './translateModal.controller';
import translateModal from './translateModal.html';

export class TranslateModalService extends InjectableClass {
  constructor($uibModal, $http, $log, translateConfig, fdTranslateModal) {
    'ngInject';
    super({ $uibModal, $http, $log, translateConfig, fdTranslateModal });
  }

  open(data) {
    const { customs = null, custom = null } = this.fdTranslateModal;
    const customization = { customs, custom };

    // Check if the translate-server is up and running
    return this.healthCheck().then(() => {
      return this.$uibModal.open({
        animation: true,
        template: translateModal,
        windowClass: 'translate-modal',
        controller: TranslateModalController,
        controllerAs: 'vm',
        resolve: {
          translate: () => data,
          customization: () => customization
        }
      }).result;
    }).catch(err => {
      this.$log.error('Translation healthCheck failed', err);
    });
  }

  save(data) {
    const { $http, translateConfig } = this;
    return $http.post(translateConfig.apiUrl, data);
  }

  healthCheck() {
    const { $http, translateConfig } = this;
    return $http.get(translateConfig.apiUrl);
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translate/src/modal/translateModal.service.js